module.exports = __webpack_public_path__ + "static/full-5c239ca821a12ee85015c478a1da46ca.jpg";